module.exports = __webpack_public_path__ + "img/expeditionary-stage_4.1.c872c34f.jpg";